import { Col, Container, Row } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebookF } from '@fortawesome/free-brands-svg-icons';
import { SimpleAncer } from '../../Components/button';
import google from '../../assets/images/png/google.png';
import phone from '../../assets/images/png/phone.png';
import LoginBgOne from './LoginBgOne';
import ContentBlock from '../../Components/contentBlock/ContentBlock';
import i18n from '../../i18n';

function PreLogin() {
  return (
    <LoginBgOne>
      <div className="preLogin loginWithPhone">
        <Container>
          <Row>
            <Col md={6} />
            <Col md={6}>
              <div className="content">
                <Row>
                  <Col md={12}>
                    <ContentBlock
                      heading={i18n.t('nurture_health_tips_wellness_advice')}
                      body={i18n.t('login_page_detail')}
                    />
                    <div className="btns_container">
                      <SimpleAncer to="/" text={i18n.t('continue_google')}>
                        <div>
                          <img src={google} alt="google" />
                        </div>
                      </SimpleAncer>
                      <SimpleAncer to="/" text={i18n.t('continue_facebook')}>
                        <div>
                          <FontAwesomeIcon
                            icon={faFacebookF}
                            className="facebook"
                          />
                        </div>
                      </SimpleAncer>
                      <SimpleAncer
                        to="/loginWithPhone"
                        text={i18n.t('continue_phone_number')}
                      >
                        <div>
                          <img src={phone} alt="phone" />
                        </div>
                      </SimpleAncer>
                    </div>
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </LoginBgOne>
  );
}

export default PreLogin;
